import { isObject } from 'lodash-es'
import { chat, wiki, apiDoc, git } from '#app/lib/urls'

// The exact env value will be returned by config
// but some functions need a value before, in case fetching the config crashes
export let detectedEnv: 'dev' | 'prod' | 'test' | 'federated'

const { window } = globalThis
const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/

// Test env detection depends on whats mocked in tests/utils/mock_browser_env.ts
if (globalThis.process != null) {
  // @ts-expect-error
  detectedEnv = globalThis.process.env.NODE_ENV
  if (detectedEnv === 'test') {
    await import('#app/tests/utils/mock_browser_env')
  }
  // Object.assign(globalThis, globalMocks)
} else if (location.protocol === 'http:' || ipv4Pattern.test(location.hostname)) {
  detectedEnv = 'dev'
} else {
  detectedEnv = 'prod'
}

if (detectedEnv !== 'prod' && window != null) {
  const trueAlert = window.alert
  window.alert = function (obj) {
    if (isObject(obj)) obj = JSON.stringify(obj, null, 2)
    return trueAlert(obj)
  }
} else if (detectedEnv === 'prod') {
  console.log(`
,___,
[-.-]   I've been expecting you, Mr Bond
/)__)
-"--"-
Want to make Inventaire better? Jump in!
Project chat: ${chat}
Wiki: ${wiki}
API Documentation: ${apiDoc}
Code: ${git}/inventaire
------`)
}
